/** Just the lookup surface of the i18n instance useI18N() returns. */
interface Translator {
  get: (key: string) => string;
}

/**
 * A wait as a phrase: "45 seconds", "1 minute", "12 minutes". Rounds up, so the
 * number a user is told is never shorter than the wait actually left.
 */
export function formatRetryAfter(seconds: number, i18n: Translator): string {
  const total = Math.max(0, Math.ceil(seconds));

  if (total < 60) {
    return `${total} ${i18n.get(total === 1 ? "second" : "seconds")}`;
  }

  if (total <= 90) {
    return `1 ${i18n.get("minute")}`;
  }

  return `${Math.ceil(total / 60)} ${i18n.get("minutes")}`;
}

/**
 * The lockout copy, composed from single-word keys because i18n.get() is a bare
 * lookup with no interpolation. A hard lock or an IP block points at the reset
 * flow; a progressive wait only asks the user to wait.
 */
export function lockoutMessage(
  i18n: Translator,
  code: string | undefined,
  seconds: number,
): string {
  const duration = formatRetryAfter(seconds, i18n);

  if (code === "LOGIN_DELAYED") {
    return `${i18n.get("pleaseWaitBeforeRetrying")} ${duration} ${i18n.get("beforeTryingAgain")}`;
  }

  // Ends on "or": the reset link rendered after it completes the sentence.
  return `${i18n.get("incorrectPasswordTooManyTimes")} ${i18n.get("tryAgainIn")} ${duration}, ${i18n.get("orLabel")}`;
}
